import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class colorsSource extends Vue {
    get colors(): Array<Record<string, any>> {
        return [
            {
                link: '#ff6666',
                name: 'red'
            },
            {
                link: '#ff8c66',
                name: 'orange'
            },
            {
                link: '#ffb366',
                name: 'orange'
            },
            {
                link: '#ffff66',
                name: 'yellow'
            },
            {
                link: '#d9ff66',
                name: 'yellow'
            },
            {
                link: '#8cff66',
                name: 'green'
            },
            {
                link: '#66ff8c',
                name: 'green'
            },
            {
                link: '#66ffd9',
                name: 'blue'
            },
            {
                link: '#66ffff',
                name: 'blue'
            },
            {
                link: '#66d9ff',
                name: 'blue'
            },
            {
                link: '#66b3ff',
                name: 'blue'
            },
            {
                link: '#8c66ff',
                name: 'violet'
            },
            {
                link: '#b366ff',
                name: 'violet'
            },
            {
                link: '#d966ff',
                name: 'violet'
            },
            {
                link: '#ff66ff',
                name: 'violet'
            },
            {
                link: '#ff66d9',
                name: 'violet'
            },
            {
                link: '#ff66b3',
                name: 'pink'
            },
            {
                link: '#ff668c',
                name: 'orange'
            },
            {
                link: '#ff6666',
                name: 'red'
            },
        ]
    }

}